import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import * as React from 'react';
import { resolve as urlResolve } from 'url';

const styles = require('./MockNotification.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MockNotificationProps {
    browser: 'chrome' | 'firefox';
    os: 'windows' | 'osx';
    title: string;
    body: string;
    url: string;
}

const resolveImage = (imageName: string) => {
    return urlResolve(getPackageBaseUrl(), `resources/images/webpush-mock/${imageName}`);
};

export class MockNotification extends React.Component<MockNotificationProps, {}> {
    render() {
        let browserIcon = this.props.browser === 'chrome' ? 'chrome.png' : 'firefox.png';
        return (
            <div className={classNames('notification', this.props.browser, this.props.os)}>
                <div className={classNames('title')}>{this.props.title}</div>
                <div className={classNames('body')}>{this.props.body}</div>
                <div className={classNames('url')}>{this.props.url}</div>
                <img className={classNames('browserIcon')} src={resolveImage(browserIcon)} />
                <img className={classNames('owaIcon')} src={resolveImage('outlook.png')} />
                {this.props.browser === 'chrome' && this.props.os === 'windows' && (
                    <img
                        className={classNames('browserUX')}
                        src={resolveImage('chrome_icons.png')}
                    />
                )}
            </div>
        );
    }
}
